module.exports = __webpack_public_path__ + "img/advise.078b89c6.svg";